import { Component, Input, inject } from '@angular/core';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { AddAssignedTransactionIntoAccountComponent } from 'src/app/AddThings/add-assigned-transaction-into-account/add-assigned-transaction-into-account.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { ALERT_TYPE } from 'src/app/constants';
import { TransactionRequest } from 'src/model/transactionRequest.model';

@Component({
    selector: 'app-assigned-transaction-card',
    templateUrl: './assigned-transaction-card.component.html',
    styleUrls: ['./assigned-transaction-card.component.scss'],
    standalone: false
})
export class AssignedTransactionCardComponent {
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private restApi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);


  @Input() transactionRequest: TransactionRequest;

  openAddTrasactionIntoAccountModal() {
    const modalRef = this.sharedService.openModal(AddAssignedTransactionIntoAccountComponent, "largeModal");

    modalRef.componentInstance.transactionRequest = this.transactionRequest;
  }

  confirmBeforeDelete(request: TransactionRequest) {
    const proceed = false;
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Confirm to delete this request to  " + request.CompanyCode + " that costs RM ?";
    modalRef.result.then((confirm) => {
      if (confirm)
        this.deleteRequest(this.transactionRequest.ID);
    });

    return proceed;
  }

  deleteRequest(requestId: number) {
    const xhr = this.restApi.deleteRequest(this.constructApi.getDeleteTransactionRequest(requestId));

    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.readyState == 4 && xhr.status == 200) {
          if (xhr.status == 200) {
            window.location.reload();
          }
          else {
            this.sharedService.openAlert("Opps, some errors occured. Please try again later", ALERT_TYPE.DANGER);
          }
        }
      }
    }
  }

  calculateTotal() {
    let sum = 0;

    for (let i = 0; i < this.transactionRequest.TransactionItems.length; i++) {
      sum += this.transactionRequest.TransactionItems[i].amount;
    }
    return sum
  }
}
